module.exports = __webpack_public_path__ + "static/media/DWG TrueView.b16d138e.png";